// import dataConstant from "../constants/dataConstants";

export async function getLeftMenuData() {
  return [
    // {
    //  title: 'Settings',
    //  key: 'settings',
    //  icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
    // },
    // {
    //   title: 'Documentation',
    //   key: 'documentation',
    //   url: 'https://docs.cleanuitemplate.com',
    //   target: '_blank',
    //   icon: 'icmn icmn-books',
    // },
    // {
    //   divider: true,
    // },
    {
      title: 'Dashboard',
      key: 'dashboardAlpha',
      url: '/dashboard/alpha',
      icon: 'icmn icmn-home',
      type:'Admin'
    },      
    {
      divider: true,
    },
    {
      title: 'Clients',
      key: 'client',
      icon: 'fa fa-users',
      url: '/client',
      type:'Admin'
    },
    {
      title: 'Suppliers',
      key: 'supplier',
      icon: 'icmn icmn-menu',
      url: '/supplier',
      type: 'Client'
    }, 
    {
      title: 'Inward',
      key: 'inward',
      icon: 'fa fa-cubes',
      // url: '/inward',
      children: [
        {
          title: 'Minerals',
          key: 'Minerals',
          url: '/Minerals',
          type: 'Client'
        },
        {
          title: 'Metals',
          key: 'Metal',
          url: '/Metal',
          type: 'Client'
        },
      ]
    },
    // {
    //   title: 'AntDesign Components',
    //   key: 'antComponents',
    //   icon: 'icmn icmn-menu',
    //   url: '/antd',
    // },
    // { 
    //   divider: true,
    // },                              
  ]
}
export async function getTopMenuData() {
  // const menuTopData = JSON.parse(localStorage.getItem('menuTopData'))
  // return menuTopData
  // const userData = JSON.parse(localStorage.getItem('webappuser'))
  // return [
  //    // {
  //    // title: 'Settings',
  //    // key: 'settings',
  //    // icon: 'icmn icmn-cog utils__spin-delayed--pseudo-selector',
  //    // },
  //   // {
  //   //   title: 'Docs',
  //   //   key: 'documentation',
  //   //   url: 'https://docs.cleanuitemplate.com',
  //   //   target: '_blank',
  //   //   icon: 'icmn icmn-books',
  //   // },
  //   // {
  //   //   title: 'Pages',
  //   //   key: 'pages',
  //   //   icon: 'icmn icmn-stack',
  //   //   children: [
  //   //     {
  //   //       title: 'Dashboard Alpha',
  //   //       key: 'dashboardAlpha',
  //   //       url: '/dashboard/alpha',
  //   //     }                            
  //   //   ],
  //   // },
    
  //    // Role Type : FactoryAdmin
  //    {
  //     title: 'Dashboard',
  //     key: 'dashboardAlpha',
  //     url: '/dashboard/alpha',
  //     icon: 'icmn icmn-home',
  //     type: dataConstant.RoleType.FactoryAdmin
  //   }, 
  //   // {
  //   //   title: 'Dashboard',
  //   //   key: 'dashboardAlpha',
  //   //   url: '/dashboard/alpha',
  //   //   icon: 'icmn icmn-home',
  //   //   type: dataConstant.RoleType.Supplier
  //   // },
  //   {
  //     title: 'Users',
  //     key: 'usermanagement',
  //     icon: 'icmn icmn-user',
  //     url: '/usermanagement',
  //     type: dataConstant.RoleType.FactoryAdmin
  //   }, 
  //   // {
  //   //   title: 'Suppliers',
  //   //   key: 'supplier',
  //   //   icon: 'icmn icmn-menu',
  //   //   url: '/supplier',
  //   //   type: dataConstant.RoleType.FactoryAdmin
  //   // }, 
  //   // {
  //   //   title: 'Clients',
  //   //   key: 'client',
  //   //   icon: 'fa fa-suitcase',
  //   //   url: '/client',
  //   //   type: dataConstant.RoleType.FactoryAdmin
  //   // }, 
  //   // {
  //   //   title: 'Wholesalers',
  //   //   key: 'Wholesalers',
  //   //   icon: 'fa fa-cubes',
  //   //   url: '/wholesaler',
  //   //   type: dataConstant.RoleType.FactoryAdmin
  //   // }, 
  //   {
  //     title: 'Entities',
  //     key: 'Entities',
  //     icon:'fa fa-align-justify',
  //     type: dataConstant.RoleType.FactoryAdmin,
  //     children: [
  //       {
  //         title: 'Suppliers',
  //         key: 'supplier',          
  //         url: '/supplier',
  //         type: dataConstant.RoleType.FactoryAdmin
  //       },
  //       {
  //         title: 'Clients',
  //         key: 'client',          
  //         url: '/client',
  //         type: dataConstant.RoleType.FactoryAdmin
  //       }, 
  //       {
  //         title: 'Wholesalers',
  //         key: 'Wholesalers',          
  //         url: '/wholesaler',
  //         type: dataConstant.RoleType.FactoryAdmin
  //       }
  //   ]},
  //   {
  //     title: 'Inward',
  //     key: 'inward',
  //     icon: 'fa fa-cubes',      
  //     // url: '/inward',
  //     type: dataConstant.RoleType.FactoryAdmin,
  //     children: [
  //       {
  //         title: 'Minerals',
  //         key: 'Minerals',
  //         url: `/inward/${dataConstant.InwardCategory.Minerals}`,
  //         type: dataConstant.RoleType.FactoryAdmin,
  //         RefType: dataConstant.InwardCategory.Minerals
  //       },
  //       {
  //         title: 'Metals',
  //         key: 'Metal',
  //         url: `/inward/${dataConstant.InwardCategory.Metal }`,
  //         type: dataConstant.RoleType.FactoryAdmin,
  //         RefType: dataConstant.InwardCategory.Metal 
  //       },
  //       {
  //         title: 'Findings',
  //         key: 'Findings',
  //         url: `/inward/${dataConstant.InwardCategory.Findings}`,
  //         type: dataConstant.RoleType.FactoryAdmin,
  //         RefType: dataConstant.InwardCategory.Findings 
  //       },
  //       {
  //         title: 'Accessories',
  //         key: 'Accessories',
  //         url: `/inward/${dataConstant.InwardCategory.Accessories}`,
  //         type: dataConstant.RoleType.FactoryAdmin,
  //         RefType: dataConstant.InwardCategory.Accessories 
  //       }
  //     ]
  //   },

  //   userData && userData.role === dataConstant.RoleType.Auditor ?
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.FactoryAdmin,
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.FactoryAdmin,
  //       },  
  //     ] 
  //   }
  //   :
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.FactoryAdmin,
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.FactoryAdmin,
  //       },                 
  //       {
  //         title: 'Bulk Image Upload',
  //         key: 'BulkUpload',
  //         url: `/bulkupload/${dataConstant.BulkUploadQueryStringTypesObject.JeweleryArticle}`,
  //         type: dataConstant.RoleType.FactoryAdmin,   
  //       },
  //       {
  //         title: 'Transfer Detail',
  //         key: 'transfer',         
  //         url: '/transfer',
  //         type: dataConstant.RoleType.FactoryAdmin
  //       },      
  //       {
  //         title: 'Transfer Request',
  //         key: 'transferrequest',         
  //         url: '/transferrequest',
  //         type: dataConstant.RoleType.FactoryAdmin
  //       },         
  //     ] 
  //   },        
  //   userData && userData.role !== dataConstant.RoleType.Auditor && (
  //   {
  //     title: 'Configurations ',
  //     key: 'configuration',
  //     icon: 'fa fa-cog',
  //     type: dataConstant.RoleType.FactoryAdmin,      
  //     children: [
  //       {
  //         title: 'RMCode Configuration',
  //         key: 'RMCodeConfiguration',
  //         url: '/rmcode',
  //         type: dataConstant.RoleType.FactoryAdmin,
  //       },
  //     ]
  //   }), 
    
    
  //   // Role Type : FactoryStaff
  //   {
  //     title: 'Dashboard',
  //     key: 'dashboardAlpha',
  //     url: '/dashboard/alpha',
  //     icon: 'icmn icmn-home',
  //     type: dataConstant.RoleType.FactoryStaff
  //   }, 
  //   // {
  //   //   title: 'Dashboard',
  //   //   key: 'dashboardAlpha',
  //   //   url: '/dashboard/alpha',
  //   //   icon: 'icmn icmn-home',
  //   //   type: dataConstant.RoleType.Supplier
  //   // },
  //   {
  //     title: 'Users',
  //     key: 'usermanagement',
  //     icon: 'icmn icmn-user',
  //     url: '/usermanagement',
  //     type: dataConstant.RoleType.FactoryStaff
  //   }, 
  //   // {
  //   //   title: 'Suppliers',
  //   //   key: 'supplier',
  //   //   icon: 'icmn icmn-menu',
  //   //   url: '/supplier',
  //   //   type: dataConstant.RoleType.FactoryStaff
  //   // },
  //   // {
  //   //   title: 'Clients',
  //   //   key: 'client',
  //   //   icon: 'fa fa-suitcase',
  //   //   url: '/client',
  //   //   type: dataConstant.RoleType.FactoryStaff
  //   // },  
  //   // {
  //   //   title: 'Wholesalers',
  //   //   key: 'Wholesalers',
  //   //   icon: 'fa fa-cubes',
  //   //   url: '/wholesaler',
  //   //   type: dataConstant.RoleType.FactoryStaff
  //   // }, 
  //   {
  //     title: 'Entities',
  //     key: 'Entities',
  //     icon:'fa fa-align-justify',
  //     type: dataConstant.RoleType.FactoryStaff,
  //     children: [
  //       {
  //         title: 'Suppliers',
  //         key: 'supplier',          
  //         url: '/supplier',
  //         type: dataConstant.RoleType.FactoryStaff
  //       },
  //       {
  //         title: 'Clients',
  //         key: 'client',          
  //         url: '/client',
  //         type: dataConstant.RoleType.FactoryStaff
  //       }, 
  //       {
  //         title: 'Wholesalers',
  //         key: 'Wholesalers',          
  //         url: '/wholesaler',
  //         type: dataConstant.RoleType.FactoryStaff
  //       }
  //   ]},
  //   {
  //     title: 'Inward',
  //     key: 'inward',
  //     icon: 'fa fa-cubes',      
  //     // url: '/inward',
  //     type: dataConstant.RoleType.FactoryStaff,
  //     children: [
  //       {
  //         title: 'Minerals',
  //         key: 'Minerals',
  //         url: `/inward/${dataConstant.InwardCategory.Minerals}`,
  //         type: dataConstant.RoleType.FactoryStaff,
  //         RefType: dataConstant.InwardCategory.Minerals
  //       },
  //       {
  //         title: 'Metals',
  //         key: 'Metal',
  //         url: `/inward/${dataConstant.InwardCategory.Metal}`,
  //         type: dataConstant.RoleType.FactoryStaff,
  //         RefType: dataConstant.InwardCategory.Metal 
  //       },
  //       {
  //         title: 'Findings',
  //         key: 'Findings',
  //         url: `/inward/${dataConstant.InwardCategory.Findings}`,
  //         type: dataConstant.RoleType.FactoryStaff,
  //         RefType: dataConstant.InwardCategory.Findings 
  //       },
  //       {
  //         title: 'Accessories',
  //         key: 'Accessories',
  //         url: `/inward/${dataConstant.InwardCategory.Accessories}`,
  //         type: dataConstant.RoleType.FactoryStaff,
  //         RefType: dataConstant.InwardCategory.Accessories 
  //       }
  //     ]
  //   },
  //   // Supplier Menu
  //   {
  //     title: 'Dashboard',
  //     key: 'dashboardAlpha',
  //     url: '/dashboard/alpha',
  //     icon: 'icmn icmn-home',
  //     type: dataConstant.RoleType.Supplier
  //   }, 
  //   {
  //     title: 'Inward',
  //     key: 'inward',
  //     icon: 'fa fa-cubes',      
  //     type: dataConstant.RoleType.Supplier,
  //     children: [
  //       {
  //         title: 'Minerals',
  //         key: 'Minerals',
  //         url: `/inward/${dataConstant.InwardCategory.Minerals}`,
  //         type: dataConstant.RoleType.Supplier,
  //         RefType: dataConstant.InwardCategory.Minerals
  //       },
  //       {
  //         title: 'Metals',
  //         key: 'Metal',
  //         url: `/inward/${dataConstant.InwardCategory.Metal}`,
  //         type: dataConstant.RoleType.Supplier,
  //         RefType: dataConstant.InwardCategory.Metal       
  //       },
  //       {
  //         title: 'Findings',
  //         key: 'Findings',
  //         url: `/inward/${dataConstant.InwardCategory.Findings}`,
  //         type: dataConstant.RoleType.Supplier,
  //         RefType: dataConstant.InwardCategory.Findings 
  //       },
  //       {
  //         title: 'Accessories',
  //         key: 'Accessories',
  //         url: `/inward/${dataConstant.InwardCategory.Accessories}`,
  //         type: dataConstant.RoleType.Supplier,
  //         RefType: dataConstant.InwardCategory.Accessories 
  //       }
  //     ]
  //   },  
  //    // Jewellery articles for FactoryAdmin and FactoryStaff
  //   userData && userData.role === dataConstant.RoleType.Auditor ?
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.FactoryStaff,
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.FactoryStaff,
  //       },   
  //     ] 
  //   }
  //   :
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.FactoryStaff, 
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.FactoryStaff,
  //       },
  //       {
  //         title: 'Bulk Image Upload',
  //         key: 'BulkUpload',
  //         url: `/bulkupload/${dataConstant.BulkUploadQueryStringTypesObject.JeweleryArticle}`,
  //         type: dataConstant.RoleType.FactoryStaff,   
  //       },
  //       {
  //         title: 'Transfer Detail',
  //         key: 'transfer',          
  //         url: '/transfer',
  //         type: dataConstant.RoleType.FactoryStaff
  //       },
  //       {
  //         title: 'Transfer Request',
  //         key: 'transferrequest',         
  //         url: '/transferrequest',
  //         type: dataConstant.RoleType.FactoryStaff
  //       },             
  //     ]
  //   },    
  //   userData && userData.role !== dataConstant.RoleType.Auditor && (      
  //   {
  //     title: 'Configurations ',
  //     key: 'configuration',
  //     icon: 'fa fa-cog',
  //     type: dataConstant.RoleType.FactoryStaff,      
  //     children: [
  //       {
  //         title: 'RMCode Configuration',
  //         key: 'RMCodeConfiguration',
  //         url: '/rmcode',
  //         type: dataConstant.RoleType.FactoryStaff,
  //       },
  //     ]
  //   }),
  //   // // Supplier Menu
  //   // {
  //   //   title: 'Dashboard',
  //   //   key: 'dashboardAlpha',
  //   //   url: '/dashboard/alpha',
  //   //   icon: 'icmn icmn-home',
  //   //   type: dataConstant.RoleType.Supplier
  //   // }, 
  //   // {
  //   //   title: 'Inward',
  //   //   key: 'inward',
  //   //   icon: 'fa fa-cubes',      
  //   //   type: dataConstant.RoleType.Supplier,
  //   //   children: [
  //   //     {
  //   //       title: 'Minerals',
  //   //       key: 'Minerals',
  //   //       url: '/Minerals',
  //   //       type: dataConstant.RoleType.Supplier,
  //   //       RefType:dataConstant.InwardCategory.Minerals
  //   //     },
  //   //     {
  //   //       title: 'Metals',
  //   //       key: 'Metal',
  //   //       url: '/Metal',
  //   //       type: dataConstant.RoleType.Supplier,
  //   //       RefType:dataConstant.InwardCategory.Metal       
  //   //     },
  //   //   ]
  //   // },  
   
  //   // Client Menu
  //   {
  //     title: 'Dashboard',
  //     key: 'dashboardAlpha',
  //     url: '/dashboard/alpha',
  //     icon: 'icmn icmn-home',
  //     type: dataConstant.RoleType.Client
  //   }, 
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.Client,
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.Client,
  //       },
  //       {
  //         title: 'Transfer Detail',
  //         key: 'transfer',          
  //         url: '/transfer',
  //         type: dataConstant.RoleType.Client
  //       },
  //       {
  //         title: 'Transfer Request',
  //         key: 'transferrequest',         
  //         url: '/transferrequest',
  //         type: dataConstant.RoleType.Client
  //       },                  
  //     ]
  //   },   

  //   // Wholesaler Menu
  //   {
  //     title: 'Dashboard',
  //     key: 'dashboardAlpha',
  //     url: '/dashboard/alpha',
  //     icon: 'icmn icmn-home',
  //     type: dataConstant.RoleType.Wholesaler
  //   }, 
  //   {
  //     title: 'Jewellery articles',
  //     key: 'factory-jewellery-articles',
  //     icon: 'fa fa-gg-circle',
  //     type: dataConstant.RoleType.Wholesaler,
  //     children: [
  //       {
  //         title: 'Jewellery articles',
  //         key: 'JewelleryarticlesList',
  //         url: '/factory/jewellery-articles',
  //         type: dataConstant.RoleType.Wholesaler,
  //       } ,
  //       {
  //         title: 'Transfer Detail',
  //         key: 'transfer',          
  //         url: '/transfer',
  //         type: dataConstant.RoleType.Wholesaler
  //       },
  //       {
  //         title: 'Transfer Request',
  //         key: 'transferrequest',         
  //         url: '/transferrequest',
  //         type: dataConstant.RoleType.Wholesaler
  //       },      
  //     ]
  //   },    
        
  //   // {
  //   //   title: 'AntDesign',
  //   //   key: 'antComponents',
  //   //   icon: 'icmn icmn-menu',
  //   //   url: '/antd',
  //   // }    
  // ]
}
export async function getLoginUserType() {
  const response = JSON.parse(localStorage.getItem('webappuser'))
  return response;
}
